import View from "../framework/View";

export default class PopupViewController {
    /**
     */
    constructor() {
        /**
         * @constant
         * @type {View[]}
         */
        this.popupViews = [];

        /**
         * @constant
         * @type {Object}
         */
        this.popupById = {};
    }

    /**
     * @param {View} popupView 
     */
    addPopupView(popupView) {
        this.popupViews.push(popupView);
        this.popupById[popupView.getElementId()] = popupView;
    }

    /**
     * 
     * @param {string} viewId 
     * @returns {boolean}
     */
    isPopupVisible(viewId) {
        /**
         * @type {View}
         */
        const popup = this.popupById[viewId];
        if (!popup) {
            console.log('PopupViewController.isPopupVisible() UNKNOWN VIEW. viewId=' + viewId);
            return false;
        }
        return popup.isViewVisible();
    }

    /**
     * @param {string} viewId 
     */
    setPopupVisible(viewId) {
        // Make sure there is only 1 popup visible
        for (let i = 0; i < this.popupViews.length; i++) {
            const popupView = this.popupViews[i];
            popupView.setViewVisible(popupView.getElementId() === viewId);
        }
    }

    /**
     * @param {string} viewId 
     * @param {string} secondaryViewId
     */
    setDoublePopupVisible(viewId, secondaryViewId) {
        // Make sure there is only 1 popup visible
        for (let i = 0; i < this.popupViews.length; i++) {
            const popupView = this.popupViews[i];
            popupView.setViewVisible(popupView.getElementId() === viewId || popupView.getElementId() === secondaryViewId);
        }
    }

    hideAllPopups() {
        for (let i = 0; i < this.popupViews.length; i++) {
            this.popupViews[i].setViewVisible(false);
        }
    }

    /**
     * @param {string} viewId 
     */
    setPopupHidden(viewId) {
        /**
         * @type {View}
         */
        const popup = this.popupById[viewId];
        if (!popup) {
            console.log('PopupViewController.setPopupHidden() UNKNOWN VIEW. viewId=' + viewId);
            return;
        }

        popup.setViewVisible(false);
    }

}